/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type SubmitDesignerReviewMutationVariables = Types.Exact<{
    input: Types.SubmitDesignerReviewInput;
}>;

export type SubmitDesignerReviewMutation = {
    __typename: 'Mutation';
    submitDesignerReview: { __typename: 'GenericResponse'; success: boolean };
};

export const SubmitDesignerReviewDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'SubmitDesignerReview' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'SubmitDesignerReviewInput' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submitDesignerReview' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type SubmitDesignerReviewMutationFn = Apollo.MutationFunction<
    SubmitDesignerReviewMutation,
    SubmitDesignerReviewMutationVariables
>;

export function useSubmitDesignerReviewMutation(
    baseOptions?: Apollo.MutationHookOptions<
        SubmitDesignerReviewMutation,
        SubmitDesignerReviewMutationVariables
    >
) {
    return Apollo.useMutation<SubmitDesignerReviewMutation, SubmitDesignerReviewMutationVariables>(
        SubmitDesignerReviewDocument,
        baseOptions
    );
}
export type SubmitDesignerReviewMutationHookResult = ReturnType<
    typeof useSubmitDesignerReviewMutation
>;
export type SubmitDesignerReviewMutationResult =
    Apollo.MutationResult<SubmitDesignerReviewMutation>;
export type SubmitDesignerReviewMutationOptions = Apollo.BaseMutationOptions<
    SubmitDesignerReviewMutation,
    SubmitDesignerReviewMutationVariables
>;
